import React from "react";

export const PageImageGalleryPanelTitle = ({ text }: { text: string }) => {
  return <h3>{text}</h3>;
};

(PageImageGalleryPanelTitle as any).craft = {
  props: {
    text: "Gallery Panel Title"
  },
  related: {
    settings: () => <div>Panel Title Settings</div>
  }
};
